<template>
  <v-card height="640" class="mt-0" flat>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Clients Accounts - {{ confirmedAccounts ? (allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Classification)[0] == "Individual" ? allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Forename)[0] + " " + allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0]: allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0]) : ''}}</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" @click="close()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>

    <v-form flat color="#ffffff00">
      <v-data-table
        disable-pagination
        hide-default-footer
        :headers="account_headers"
        :fixed-header="true"
        :items="confirmedAccounts ? allClientAccounts.filter(a => a.ClientID == currentClient.ClientID) : allClientAccounts.filter(a => a.CheckerID === 0)"
        sort-by="MakeDate"
        sort-desc
        class="elevation-0"
      >

        <template v-slot:top >
          <v-dialog persistent v-model="rejectionDialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
              </v-card-title>

              <v-card-text>
                <v-select
                  filled dense
                  v-model="RejectionStatus"
                  :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="RejectionReasonDescription"
                  item-value="RejectionReasonID"
                  label="Rejection Reasons"
                ></v-select>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    ok
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog persistent v-model="deleteDialog" max-width="350px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
              </v-card-title>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    yes
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-toolbar dense flat>
            <v-toolbar-title class="grey--text caption font-weight-normal">Accounts</v-toolbar-title>
            <v-spacer/>
            <v-btn @click="create_dialog = true; Account.CurrencyID = allApplicationDefaults[0].CurrencyID" v-show="confirmedAccounts" class="text-right" small outlined color="#2A353D">
              create new
            </v-btn>
          </v-toolbar>

          <v-dialog v-if="currentAccount && ClientAccountsFees.map(c => c.AccountId).includes(currentAccount.AccountID)" v-model="fees_dialog" persistent max-width="900px">
            <v-card flat class="pa-4">

              <v-dialog v-model="fees_confirm_dialog" persistent max-width="400px">
                <v-card flat class="pa-4">
                  <v-card-text>
                    <div align="center" justify="center">
                      <v-progress-circular
                        :size="70"
                        :width="1"
                        :value="100"
                        color="red"
                        class="ma-4 mt-2"
                      >
                        <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
                      </v-progress-circular>
                    </div>
                    <h5 class="grey--text text-center font-weight-normal">Please check and confirm the Fee(s) for the Account: {{currentAccount.AccountNumber}}</h5>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="text-right">
                      <v-btn class="white--text ml-4" small color="#2A353D" @click="confirmed = true; fees_confirm_dialog = false">
                        <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        OK
                      </v-btn>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-form v-if="fees_dialog" ref="FeeForm" v-model="fees_valid" lazy-validation flat>

                <v-data-table
                  :headers="fees_headers"
                  :fixed-header="true"
                  :items="currentAccountFees"
                  disable-pagination
                  hide-default-footer dense
                  class="elevation-0 my-allocations-table mt-3"
                >

                  <template v-slot:top >
                    <v-toolbar dense flat>
                      <v-toolbar-title class="grey--text caption font-weight-normal">{{ allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Classification)[0] == "Individual" ? allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Forename)[0] + " " + allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0]: allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0] }} - Account: {{currentAccount.AccountNumber}}</v-toolbar-title>
                      <v-spacer/>
                      <v-btn class="text-right" @click="NewFee(currentAccountFees)" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.FeesId="{ item }">
                    <v-select
                      @change="getCurrentFeeDefaults(item)"
                      @click="setActiveFee(item, index)"
                      background-color="#ffffff00"
                      v-model="item.FeesId"
                      :items="Fees"
                      item-text="FeeCode"
                      item-value="FeesId"
                      :rules="TextFieldRules"
                      hide-details solo flat class="Account ma-0 pa-0"
                      placeholder="----" dense
                    ></v-select>
                  </template>

                  <!-- <template v-slot:item.IsDefault="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsDefault"
                    ></v-simple-checkbox>
                  </template> -->

                  <template v-slot:item.IsAbsolute="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsAbsolute"
                    ></v-simple-checkbox>
                  </template>

                  <template  v-slot:item.FeeValue="{ item }">
                    <v-text-field
                      v-model="item.FeeValue"
                      label="Fee Value"
                      :rules="item.IsAbsolute == true ? [
                        v => !!v || 'field is required',
                        v => (v && v > 0) || 'value cannot exceed 100%',
                        v => (v && v > 0) || 'value must exceed 0'
                      ] : 
                      [ v => !!v || 'field is required',
                        v => (v && v <= 100) || 'value cannot exceed 100%',
                        v => (v && v > 0) || 'value must exceed 0'
                      ]"
                      single-line
                      type="number"
                    ></v-text-field>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-icon small @click="removeFee(item, currentAccountFees)">mdi-close</v-icon>
                  </template>

                  <template v-slot:footer >
                    <v-divider class="mt-0"/>
                    <div class="text-right mb-4 mt-4 pt-7">
                      <v-btn class="white--text" small color="#2A353D" @click="currentAccountFees = []; fees_dialog = false">close</v-btn>
                      <v-btn class="white--text ml-4" small color="#2A353D" :disabled="!fees_valid" @click="updateFee()">
                        <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        submit
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-form>
            </v-card>
          </v-dialog>

          <v-dialog v-if="currentAccount && ClientAccountsFees.map(c => c.AccountId).includes(currentAccount.AccountID) == false" v-model="fees_dialog" persistent max-width="900px">
            <v-card flat class="pa-4">
              <v-dialog v-model="fees_confirm_dialog" persistent max-width="800px">
                <v-card flat class="pa-4">
                  <v-card-text>
                    <div align="center" justify="center">
                      <v-progress-circular
                        :size="70"
                        :width="1"
                        :value="100"
                        color="red"
                        class="ma-4 mt-2"
                      >
                        <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
                      </v-progress-circular>
                    </div>
                    <h5 class="grey--text text-center font-weight-normal">Please check and confirm the Fee(s) for the Account: {{currentAccount.AccountNumber}}</h5>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="text-right">
                      <v-btn class="white--text ml-4" small color="#2A353D" @click="confirmed = true; fees_confirm_dialog = false">
                        <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        OK
                      </v-btn>
                    </div>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-form v-if="fees_dialog" ref="FeeForm" v-model="fees_valid" lazy-validation flat>

                <v-data-table
                  :headers="fees_headers"
                  :fixed-header="true"
                  :items="AccountFees"
                  disable-pagination
                  hide-default-footer dense
                  class="elevation-0 my-allocations-table mt-3"
                >

                  <template v-slot:top >
                    <v-toolbar dense flat>
                      <v-toolbar-title class="grey--text caption font-weight-normal">{{ allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Classification)[0] == "Individual" ? allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Forename)[0] + " " + allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0]: allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0] }} - Account: {{currentAccount.AccountNumber}}</v-toolbar-title>
                      <v-spacer/>
                      <v-btn :disabled="view" class="text-right" @click="NewFee(AccountFees)" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.FeesId="{ item }">
                    <v-select
                      @change="getCurrentFeeDefaults(item)"
                      @click="setActiveFee(item, index)"
                      background-color="#ffffff00"
                      v-model="item.FeesId"
                      :items="Fees"
                      item-text="FeeCode"
                      item-value="FeesId"
                      :rules="TextFieldRules"
                      hide-details solo flat class="Account ma-0 pa-0"
                      placeholder="----" dense
                    ></v-select>
                  </template>

                  <!-- <template v-slot:item.IsDefault="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsDefault"
                    ></v-simple-checkbox>
                  </template> -->

                  <template v-slot:item.IsAbsolute="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsAbsolute"
                    ></v-simple-checkbox>
                  </template>

                  <template  v-slot:item.FeeValue="{ item }">
                    <v-text-field
                      v-model="item.FeeValue"
                      label="Fee Value"
                      :rules="item.IsAbsolute == true ? [
                        v => !!v || 'field is required',
                        v => (v && v > 0) || 'value cannot exceed 100%',
                        v => (v && v > 0) || 'value must exceed 0'
                      ] : 
                      [ v => !!v || 'field is required',
                        v => (v && v <= 100) || 'value cannot exceed 100%',
                        v => (v && v > 0) || 'value must exceed 0'
                      ]"
                      single-line
                      type="number"
                    ></v-text-field>
                  </template>

                  <template v-slot:item.action="{ item }">
                    <v-icon small @click="removeFee(item, AccountFees)">mdi-close</v-icon>
                  </template>

                  <template v-slot:footer >
                    <v-divider class="mt-0"/>
                    <div class="text-right mb-4 mt-4 pt-7">
                      <v-btn class="white--text" small color="#2A353D" @click="AccountFees = []; fees_dialog = false">close</v-btn>
                      <v-btn class="white--text ml-4" small color="#2A353D" :disabled="!fees_valid" @click="createFee()">
                        <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        submit
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-form>
            </v-card>
          </v-dialog>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

          <v-dialog v-model="create_dialog" persistent max-width="700px">
            <v-card flat>
              <v-form v-if="create_dialog" ref="CreateForm" v-model="create_valid" lazy-validation flat>
                <v-card-title>
                  <span class="subtitle-1 grey--text mt-2">New Account - {{ allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Classification)[0] == "Individual" ? allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Forename)[0] + " " + allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0]: allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0] }}</span>
                </v-card-title>

                <v-row class="ml-1 mr-1">
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="Account.AccountNumber"
                      label="Account Number"
                      required
                      disabled
                      placeholder="----"
                    ></v-text-field>
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="Account.AccountDesc"
                      label="Account Description"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 150) || 'field must be less than 150 characters'
                      ]"
                      placeholder="----"
                    ></v-text-field>
                    <v-select
                      outlined dense
                      v-model="Account.CallAccountTypeID"
                      :items="AccountTypes"
                      item-text="CallAccountType"
                      item-value="CallAccountTypeID"
                      placeholder="----"
                      label="Account Type"
                    ></v-select>
                    <v-select
                      outlined dense
                      v-model="Account.OfficeId"
                      :items="allOffices.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="Name"
                      item-value="OfficeId"
                      placeholder="----"
                      label="Processing Office"
                    ></v-select>
                    <v-select
                      light dense outlined
                      color="#2A353D"
                      v-model="Account.FeeFrequencyAccrual"
                      :items="AccountFrequencies"
                      item-text="Frequency"
                      item-value="FrequencyID"
                      label="(Accrual) Fee Frequency"
                      placeholder="----"
                    ></v-select>
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-select
                      outlined dense
                      v-model="Account.FundAccountType"
                      :items="allFundAccountTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="FundAccName"
                      item-value="FundAccTypeId"
                      placeholder="----"
                      label="Fund Account Type"
                    ></v-select>
                    <v-select
                      outlined dense
                      v-model="Account.AccountStatusID"
                      :items="allAccountStatuses.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="AccountStatusDescription"
                      item-value="AccountStatusID"
                      placeholder="----"
                      label="Account Status"
                    ></v-select>
                    <v-select
                      outlined dense
                      v-model="Account.CurrencyID"
                      :items="allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CurrencyCode"
                      item-value="CurrencyID"
                      placeholder="----"
                      label="Currency Code"
                    ></v-select>
                    <v-select
                      outlined dense
                      v-model="Account.OfficerId"
                      :items="allUsers.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="FullName"
                      item-value="SecurityUserID"
                      placeholder="----"
                      label="Relationship Officer"
                    ></v-select>
                    <v-select
                      light dense outlined
                      color="#2A353D"
                      v-model="Account.FeeFrequencyCharge"
                      :items="AccountFrequencies"
                      item-text="Frequency"
                      item-value="FrequencyID"
                      label="(Charge) Fee Frequency"
                      placeholder="----"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="ml-2 mr-2">
                  <v-col class="pb-0 pt-4">
                    <div class="text-right mb-4 mt-4">
                      <v-btn class="white--text mr-4" small color="#2A353D" @click="create_dialog = false; resetCreate()">back</v-btn>
                      <v-btn class="white--text" small color="#2A353D" :disabled="!create_valid" @click="createNew()">
                        <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        submit
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-dialog>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

          <v-dialog v-if="currentAccount" v-model="edit_dialog" persistent max-width="700px">
            <v-card flat>
              <v-form v-if="edit_dialog" ref="EditForm" v-model="edit_valid" lazy-validation flat>
                <v-card-title>
                  <span class="subtitle-1 grey--text mt-2">{{ allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Classification)[0] == "Individual" ? allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.Forename)[0] + " " + allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0]: allClients.filter(a => a.ClientID == currentClient.ClientID).map(a => a.MajorName)[0] }}</span>
                  <v-spacer/>
                  <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentAccount.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
                  <span v-if="currentAccount.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentAccount.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
                  <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentAccount.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
                </v-card-title>

                <v-row class="ml-1 mr-1">
                  <v-col class="pb-0 pt-0">
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="currentAccount.AccountNumber"
                      label="Account Number"
                      required
                      disabled
                      placeholder="----"
                    ></v-text-field>
                    <v-text-field
                      light dense outlined
                      color="#2A353D"
                      v-model="currentAccount.AccountDesc"
                      label="Account Description"
                      :readonly="view"
                      required
                      :rules="[
                        v => !!v || 'field is required',
                        v => (v && v.length <= 150) || 'field must be less than 150 characters'
                      ]"
                      placeholder="----"
                    ></v-text-field>
                    <v-select
                      outlined dense
                      v-model="currentAccount.CallAccountTypeID"
                      :items="AccountTypes"
                      item-text="CallAccountType"
                      item-value="CallAccountTypeID"
                      :readonly="view"
                      placeholder="----"
                      label="Account Type"
                    ></v-select>
                    <v-select
                      outlined dense
                      v-model="currentAccount.OfficeId"
                      :items="allOffices.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="Name"
                      item-value="OfficeId"
                      :readonly="view"
                      placeholder="----"
                      label="Processing Office"
                    ></v-select>
                    <v-select
                      light dense outlined
                      color="#2A353D"
                      v-model="currentAccount.FeeFrequencyAccrual"
                      :items="AccountFrequencies"
                      item-text="Frequency"
                      item-value="FrequencyID"
                      label="(Accrual) Fee Frequency"
                      placeholder="----"
                    ></v-select>
                  </v-col>
                  <v-col class="pb-0 pt-0">
                    <v-select
                      outlined dense
                      v-model="currentAccount.FundAccountType"
                      :items="allFundAccountTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="FundAccName"
                      item-value="FundAccTypeId"
                      :readonly="view"
                      placeholder="----"
                      label="Fund Account Type"
                    ></v-select>
                    <v-select
                      outlined dense
                      v-model="currentAccount.AccountStatusID"
                      :items="allAccountStatuses.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="AccountStatusDescription"
                      item-value="AccountStatusID"
                      :readonly="view"
                      placeholder="----"
                      label="Account Status"
                    ></v-select>
                    <v-select
                      outlined dense
                      v-model="currentAccount.CurrencyID"
                      :items="allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CurrencyCode"
                      item-value="CurrencyID"
                      :readonly="view"
                      placeholder="----"
                      label="Currency Code"
                    ></v-select>
                    <v-select
                      outlined dense
                      v-model="currentAccount.OfficerId"
                      :items="allUsers.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="FullName"
                      item-value="SecurityUserID"
                      :readonly="view"
                      placeholder="----"
                      label="Relationship Officer"
                    ></v-select>
                    <v-select
                      light dense outlined
                      color="#2A353D"
                      v-model="currentAccount.FeeFrequencyCharge"
                      :items="AccountFrequencies"
                      item-text="Frequency"
                      item-value="FrequencyID"
                      label="(Charge) Fee Frequency"
                      placeholder="----"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row class="ml-2 mr-2">
                  <v-col class="pb-0 pt-4">
                    <div class="text-right mb-4 mt-4">
                      <v-btn class="white--text" small color="#2A353D" @click="edit_dialog = false; view = false">back</v-btn>
                      <v-btn class="white--text ml-4" v-if="!view" small color="#2A353D" :disabled="!edit_valid" @click="update()">
                        <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                        submit
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-dialog>

        </template>

        <template v-slot:item.ClientID="{ item }">
          <span
            class="d-inline-block text-truncate"
            style="max-width: 230px;"
          >
          {{allClients.filter(a => a.ClientID == item.ClientID).map(a => a.MajorName)[0]}}
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            small outlined
            @click="currentAccountFees = ClientAccountsFees.filter(c => c.AccountId == item.AccountID); setActiveAccount(item, index); getFees(item.CurrencyID); fees_dialog = true"
            color="#2A353D" class="mr-3"
            :disabled="item.RejectionID !== 0"
          >
            <span>fees</span>
          </v-btn>
          <v-tooltip v-if="!confirmedAccounts && item.CheckerID == 0" top>
            <template v-slot:activator="{ on }">
            <v-btn
              small @click="setActiveAccount(item, index); updateStatus()"
              outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
              v-on="on"
              color="#2A353D" class="mr-3"
            >
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
            </v-btn>
            </template>
            <span>confirm</span>
          </v-tooltip>
          <v-tooltip v-if="!confirmedAccounts && item.CheckerID == 0" top>
            <template v-slot:activator="{ on }">
            <v-btn
              small @click="setActiveAccount(item, index); rejectionDialog = true"
              outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
              v-on="on"
              color="#2A353D" class="mr-3"
            >
              reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
            </v-btn>
            </template>
            <span>reject</span>
          </v-tooltip>
          <v-btn
            v-show="confirmedAccounts"
            small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
            @click="setActiveAccount(item, index); edit_dialog = true"
            color="#2A353D" class="mr-3"
          >
            <span>edit</span>
          </v-btn>
          <v-btn
            small outlined
            :disabled="edit"
            @click="setActiveAccount(item, index); view = true; edit_dialog = true"
            color="#2A353D" class="mr-3"
          >
            <span>view</span>
          </v-btn>
          <v-icon
            :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
            color="#2A353D" @click="setActiveAccount(item, index); deleteDialog = true"
          >
          mdi-trash-can-outline
          </v-icon>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
          <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
          <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
        </template>

      </v-data-table>
    </v-form>

  </v-card>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
// import dealingService from '../services/dealing.service';
import administrationService from '../services/administration.service';
// import UserService from '../services/user.service';

export default {
  data () {
    return {
      currentAccount: null,
      create_dialog: false,
      view: false,
      edit_dialog: false,
      fees_dialog: false,
      fees_confirm_dialog: false,
      deleteDialog: false,
      rejectionDialog: false,
      confirmed: false,
      loading: false,
      RejectionStatus: 0,
      message: '',
      menu: false,
      menu_2: false,
      account_headers: [
        { text: 'Client', align: 'start', value: 'ClientID'},
        { text: 'Account Number', align: 'start', sortable: true, value: 'AccountNumber'},
        { text: 'Description' , value: 'AccountDesc', sortable: false},
        { text: 'Status', value: 'status', sortable: false },
        { value: 'action', align: 'end', sortable: false },
      ],
      fees_headers: [
        { text: 'Fee', align: 'start', value: 'FeesId', width: 200},
        // { text: 'Default Option', value: 'IsDefault'},
        { text: 'Is Absolute', value: 'IsAbsolute', sortable: false },
        { text: 'Fee Value', value: 'FeeValue', sortable: false },
        { text: 'Effective Date', value: 'EffectiveDate', sortable: false },
        { value: 'action', align: 'end', sortable: false },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      tab: null,
      create_valid: true,
      fees_valid: true,
      edit_valid: true,
      Account: {
        AccountStatusID: 1,
        FundAccountType: 0,
        CallAccountTypeID: 1
      },
      AccountFees: [],
      Fees: [],
      AccountFrequencies: [],
      AccountTypes: [],
      currentAccountFees: [],
      ClientAccountsFees: null,
      DefaultAccountsFees: null,
      IncomeTypes: null,
      errors: []
    }
  },

  props: ['currentClient', 'confirmedAccounts'],

  computed: {
    ...mapGetters([
      "allClients",
      "allClientAccounts",
      "allFundAccountTypes",
      "allCurrencies",
      "allCallAccountTypes",
      "allOffices",
      "allAccountStatuses",
      "allUsers",
      "allRejectionReasons",
      "currentSystemDate",
      "allConfirmationSettings",
      "allApplicationDefaults"
    ]),

    currentUser() {
      return this.$store.state.auth.user;
    },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 302).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  // watch: {
  //   'currentAccount.DateClosed': {
  //     handler: function(newValue) {
  //       if(newValue != null && newValue != ''){
  //         var data = {
  //           Date: newValue,
  //         };

  //         dealingService.checkIsWeekendHoliday(data)
  //         .then(response => {
  //           this.errors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
  //         })
  //       }
  //     },
  //     deep: true
  //   }
  // },

  created(){
    administrationService.getAllClientAccountFees()
    .then(response => {
      this.ClientAccountsFees = response.data
    }),

    administrationService.getAllDefaultAccountFees()
    .then(response => {
      this.DefaultAccountsFees = response.data
    }),

    administrationService.getAccountFrequencies()
    .then(response => {
      this.AccountFrequencies = response.data
    })

    this.getAccountTypes()
  },

  methods: {
    ...mapActions([
      "createClientAccount",
      "updateClientAccount",
      "deleteClientAccount"
    ]),

    async createNew() {
      this.message = '';
      this.loading = true;

      await this.validateCreate()

      if (this.create_valid == true) {
        this.Account.DateOpened = this.currentSystemDate.DayDate,
        this.Account.MakerID = this.currentUser.SecurityUserID,
        this.Account.CheckerID = this.CheckerID,
        this.Account.LastUserID = this.currentUser.SecurityUserID,
        this.Account.ClientID = this.currentClient.ClientID,

        this.createClientAccount(this.Account)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newClientAccount',
            data: response.data
          });
          this.message = response.data.message
          this.resetCreate();
          this.loading = false;
          this.create_dialog = false
        },
        error => {
        this.loading = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    async createFee() {
      this.message = '';
      this.loading = true;

      await this.validateFee()

      if (this.fees_valid == true) {
        if(this.confirmed == true){
          var Data = {
            MakerID: this.currentUser.SecurityUserID,
            LastUserID: this.currentUser.SecurityUserID,
            AccountId: this.currentAccount.AccountID,
            fees: this.AccountFees
          }

          administrationService.createClientAccountFees(Data)
          .then(response =>{
            this.loading = false;
            this.message = response.data.message
            this.fees_dialog = false
            this.confirmed = false
          },
          error => {
          this.loading = false;
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.fees_dialog = false
            this.confirmed = false
          })
        } else {
          this.fees_confirm_dialog = true
        }
      }
    },

    async update() {
      this.message = '';
      this.loading = true;

      await this.validateEdit()

      if (this.edit_valid == true) {
        if(this.currentAccount.CheckerID == 0){
          this.currentAccount.LastUserID = this.currentUser.SecurityUserID,
          this.currentAccount.RejectionID = this.RejectionStatus,
          this.currentAccount.CheckerID = 0,
          this.currentAccount.CheckDate = null,

          this.updateClientAccount(this.currentAccount)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updClientAccount',
              data: this.currentAccount
            });
            
            this.message = response.data.message
            this.loading = false
            this.edit_dialog = false
          },
          error => {
          this.loading = false;
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        } else {
          this.currentAccount.MakerID = this.currentUser.SecurityUserID
          this.currentAccount.LastUserID = this.currentUser.SecurityUserID,
          this.currentAccount.RejectionID = this.RejectionStatus,
          this.currentAccount.CheckerID = 0,
          this.currentAccount.CheckDate = null,
          this.currentAccount.MakeDate = new Date(),

          this.updateClientAccount(this.currentAccount)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updClientAccount',
              data: this.currentAccount
            });
            
            this.message = response.data.message
            this.loading = false
            this.edit_dialog = false
          },
          error => {
          this.loading = false;
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        }
      }
    },

    async updateFee() {
      this.message = '';
      this.loading = true;

      await this.validateFee()

      if (this.fees_valid == true) {
        if(this.confirmed == true){
          var Data = {
            MakerID: this.currentUser.SecurityUserID,
            LastUserID: this.currentUser.SecurityUserID,
            AccountId: this.currentAccount.AccountID,
            fees: this.currentAccountFees
          }

          administrationService.updateClientAccountFees(Data)
          .then(response =>{
            this.message = response.data.message
            this.loading = false
            this.fees_dialog = false
            this.confirmed = false
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
            this.loading = false
            this.fees_dialog = false
            this.confirmed = false
          })
        } else {
          this.fees_confirm_dialog = true
        }
      }
    },

    deleteItem() {
      this.message = '';
      this.loading = true;
      this.deleteClientAccount(this.currentAccount)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltClientAccount',
          data: this.currentAccount
        });
        
        this.message = response.data.message
        this.loading = false
        this.deleteDialog = false
      },
      error => {
      this.loading = false;
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    updateStatus() {
      this.message = '';
      this.loading = true;

      this.currentAccount.CheckerID = this.currentUser.SecurityUserID,
      this.currentAccount.LastUserID = this.currentUser.SecurityUserID,
      this.currentAccount.RejectionID = this.RejectionStatus,
      this.currentAccount.CheckDate = new Date(),
      this.currentAccount.updatedAt = new Date(),

      this.updateClientAccount(this.currentAccount)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updClientAccount',
          data: this.currentAccount
        });
        
        this.message = response.data.message
        this.loading = false
        this.rejectionDialog = false;
        this.RejectionStatus = 0
      },
      error => {
      this.loading = false
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getAccountTypes(){
      if(this.currentUser.roles.map(r => r.role_name.map(a => a.RoleCode)[0]).includes("ADMIN")){
        administrationService.getAllAdminAccountTypes()
        .then(response =>{
          this.AccountTypes = response.data
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      } else {
        administrationService.getAllGeneralAccountTypes()
        .then(response =>{
          this.AccountTypes = response.data
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getFees(currency){

      administrationService.getFeesByCurr(currency)
      .then(response =>{
        this.Fees = response.data
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validateCreate () {
      this.$refs.CreateForm.validate()
      return this.create_valid
    },

    validateEdit () {
      this.$refs.EditForm.validate()
      return this.edit_valid
    },

    validateFee () {
      this.$refs.FeeForm.validate()
      return this.fees_valid
    },

    resetCreate () {
      this.Account = {
        AccountStatusID: 1,
        FundAccountType: 0,
        CallAccountTypeID: 1
      }
    },

    NewFee(item) {
      item.push(
        {
          FeesId: null,
          IsDefault: false,
          IsAbsolute: false,
          FeeValue: 0,
          EffectiveDate: this.currentSystemDate.DayDate,
        }
      )
    },

    removeFee(item, parent) {
      const index = parent.findIndex(p => p.FeesId === item.FeesId);
      parent.splice(index, 1)
    },

    close() {
     this.$root.$emit("closeClientDialog")
    },

    setActiveAccount (item, index) {
      this.currentAccount = item
      this.currentIndex = index
    },
  },
}
</script>

<style scoped>

.v-btn {
  outline: none
}

</style>